<template>
	<div class="moments-app">
		<ViewMultiFormat
			v-if="eventId"
			:event-id="eventId"
			:is-community-cropping="true"
		/>
	</div>
</template>

<script>
import ViewMultiFormat from '@shared/Views/ViewMultiFormat.vue';

export default {
	name:       'MomentsApp',
	components: { ViewMultiFormat },
	computed:   {
		eventId() {
			const eventId = Number(window.multiFormatEventId);

			return Number.isFinite(eventId) ? eventId : null;
		},
	},
};

</script>

<style lang="scss" scoped>
.moments-app {
	height: 100%;
}
</style>
